// extracted by mini-css-extract-plugin
export default {"wrap":"PriceTableSingleComponent_wrap__ckZoA","item":"PriceTableSingleComponent_item__ru4Gq"};